export enum StepEnum {
  SelectBusinessPartner,
  SelectAgreement,
  ReviewAgreement,
}
export type StepKey = keyof typeof StepEnum;

export enum AgreementCreationType {
  New,
  Existing,
}

export enum AgreementType {
  FullService,
  LimitedService,
}
